export { EloSofortIcon } from './sofort-icon'
